import React from 'react';
import { Link } from 'react-router-dom';
import logImage from '../assets/log.jpg';
import gmailIcon from '../assets/gmail.png';
import whatsappIcon from '../assets/whatsapp.png';
import placeholderIcon from '../assets/placeholder.png';
import leftArrow from '../assets/left.png';
import { FaLinkedin, FaInstagram, FaFacebook, FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  return (
    <div className="min-h-screen bg-[var(--bg)]" style={{ fontFamily: 'var(--font-body)' }}>
      <div className="relative">
        <img src={logImage} alt="Drogastro clinic" className="w-full h-36 md:h-44 object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)]/80 via-[#2563EB]/20 to-transparent" />
        <Link to="/" className="absolute top-4 left-4">
          <span className="flex items-center justify-center w-9 h-9 rounded-full bg-white/90 shadow-sm hover:bg-white transition-colors">
            <img src={leftArrow} alt="Back" className="w-4 h-4 object-contain" />
          </span>
        </Link>
        <div className="absolute bottom-0 left-0 right-0 px-5 md:px-8 pb-4">
          <span className="text-[11px] tracking-wider text-[#2563EB]" style={{ fontFamily: 'var(--font-mono)' }}>
            GET IN TOUCH
          </span>
          <h1
            className="text-2xl md:text-3xl font-medium text-white"
            style={{ fontFamily: 'var(--font-display)' }}
          >
            Let's Collaborate!
          </h1>
          <p className="text-white/80 text-sm md:text-base mt-1">Our team is always available to assist you.</p>
        </div>
      </div>

      <div className="container mx-auto flex flex-col md:flex-row gap-8 p-5 md:p-8 -mt-2">
        <form
          className="flex-1 max-w-lg bg-white rounded-2xl border border-[var(--mist)] shadow-sm p-6 md:p-7"
          action="/action_page.php"
          target="_blank"
        >
          <h2
            className="text-lg font-medium text-[var(--ink)] mb-5"
            style={{ fontFamily: 'var(--font-display)' }}
          >
            Send us a message
          </h2>

          <div className="mb-4">
            <label className="block text-xs font-semibold text-[var(--ink)]/70 mb-1.5" style={{ fontFamily: 'var(--font-mono)' }}>
              NAME
            </label>
            <input
              className="w-full p-2.5 border border-[var(--mist)] rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-[#2563EB] focus:border-transparent transition-shadow"
              type="text"
              name="Name"
              placeholder="Your full name"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-xs font-semibold text-[var(--ink)]/70 mb-1.5" style={{ fontFamily: 'var(--font-mono)' }}>
              PHONE NUMBER
            </label>
            <input
              className="w-full p-2.5 border border-[var(--mist)] rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-[#2563EB] focus:border-transparent transition-shadow"
              type="text"
              name="Phone"
              placeholder="01xxxxxxxxx"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-xs font-semibold text-[var(--ink)]/70 mb-1.5" style={{ fontFamily: 'var(--font-mono)' }}>
              EMAIL
            </label>
            <input
              className="w-full p-2.5 border border-[var(--mist)] rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-[#2563EB] focus:border-transparent transition-shadow"
              type="email"
              name="email"
              placeholder="you@example.com"
              required
            />
          </div>
          <div className="mb-5">
            <label className="block text-xs font-semibold text-[var(--ink)]/70 mb-1.5" style={{ fontFamily: 'var(--font-mono)' }}>
              MESSAGE
            </label>
            <textarea
              className="w-full p-2.5 border border-[var(--mist)] rounded-xl text-base h-32 resize-none focus:outline-none focus:ring-2 focus:ring-[#2563EB] focus:border-transparent transition-shadow"
              name="message"
              placeholder="How can we help?"
              required
            ></textarea>
          </div>
          <button
            type="submit"
            className="w-full sm:w-auto bg-[#2563EB] hover:bg-blue-700 text-white font-medium py-2.5 px-8 rounded-full text-base shadow-sm transition-colors duration-200"
          >
            Send Message
          </button>
        </form>

        <div className="md:w-80 space-y-4 h-fit">
          <div className="bg-white rounded-2xl border border-[var(--mist)] shadow-sm p-6 text-[var(--ink)] text-base">
            <h3 className="text-xs font-semibold text-[var(--ink)]/60 mb-4" style={{ fontFamily: 'var(--font-mono)' }}>
              CONTACT DETAILS
            </h3>
            <div className="space-y-4">
              <p className="flex items-center gap-3">
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#2563EB]/10 shrink-0">
                  <img src={gmailIcon} alt="Email icon" className="w-5 h-5" />
                </span>
                <span className="text-sm">info@medical.com</span>
              </p>
              <p className="flex items-center gap-3">
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#2563EB]/10 shrink-0">
                  <img src={whatsappIcon} alt="WhatsApp icon" className="w-5 h-5" />
                </span>
                <span className="text-sm">01023456789</span>
              </p>
              <p className="flex items-start gap-3">
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#2563EB]/10 shrink-0">
                  <img src={placeholderIcon} alt="Location pin icon" className="w-5 h-5" />
                </span>
                <span className="text-sm leading-snug pt-1.5">5th avenue, New city, Cairo</span>
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-[var(--mist)] shadow-sm p-6">
            <h3 className="text-xs font-semibold text-[var(--ink)]/60 mb-4" style={{ fontFamily: 'var(--font-mono)' }}>
              FOLLOW US
            </h3>
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 rounded-full bg-[var(--bg)] border border-[var(--mist)] text-[var(--ink)]/70 hover:text-white hover:bg-[#2563EB] hover:border-[#2563EB] transition-colors duration-200"
              >
                <FaLinkedin className="text-lg" />
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 rounded-full bg-[var(--bg)] border border-[var(--mist)] text-[var(--ink)]/70 hover:text-white hover:bg-[#2563EB] hover:border-[#2563EB] transition-colors duration-200"
              >
                <FaInstagram className="text-lg" />
              </a>
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 rounded-full bg-[var(--bg)] border border-[var(--mist)] text-[var(--ink)]/70 hover:text-white hover:bg-[#2563EB] hover:border-[#2563EB] transition-colors duration-200"
              >
                <FaFacebook className="text-lg" />
              </a>
              <a
                href="https://www.whatsapp.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 rounded-full bg-[var(--bg)] border border-[var(--mist)] text-[var(--ink)]/70 hover:text-white hover:bg-[#2563EB] hover:border-[#2563EB] transition-colors duration-200"
              >
                <FaWhatsapp className="text-lg" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
